import { useTranslation } from 'react-i18next'
import { FormikProvider, useFormik } from 'formik'
import { object, string } from 'yup'

import { Spacer, Text, Modal, ConfirmationModal } from '@percent/lemonade'
import { RemoveUserModalProps } from './RemoveUserModal.types'
import { useMutation } from '@percent/partner-dashboard/common/hooks'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export function RemoveUserModal({ openModalData, onClose, refresh }: RemoveUserModalProps) {
  const { t } = useTranslation()
  const { iamService } = useServices()

  const [{ isLoading: isSaving }, { apiFunc: deleteAccount }] = useMutation(iamService.deleteAccount, () => {
    refresh()
    onClose()
  })

  const formik = useFormik({
    initialValues: { userId: openModalData?.userId },
    validationSchema: () =>
      object().shape({
        userId: string()
      }),
    onSubmit: () => {
      if (openModalData) {
        deleteAccount({
          userId: openModalData.userId
        })
      }
    }
  })

  const { handleSubmit } = formik

  return (
    <Modal open={Boolean(openModalData)} onClose={onClose} aria-labelledby="remove-member-modal">
      <ConfirmationModal
        title={t('dialog.removeUser.title')}
        loading={isSaving}
        primaryButtonText={t('button.removeMember')}
        secondaryButtonText={t('button.cancel')}
        handleSubmit={handleSubmit}
        handleClose={onClose}
      >
        <form onSubmit={handleSubmit}>
          <FormikProvider value={formik}>
            <span style={{ fontWeight: 500 }}>{openModalData?.email}</span>{' '}
            <Text> {t('dialog.removeUser.willBeRemovedInfo')}</Text>
            <Spacer size={4} axis="vertical" />
            <Text>{t('dialog.removeUser.areYouSureInfo')}</Text>
          </FormikProvider>
        </form>
      </ConfirmationModal>
    </Modal>
  )
}
